import { EnvironmentInjector, Injectable, runInInjectionContext } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { InfoEvent } from '../models/types.model';
import { DbService } from './db.service';

/**
 * Servicio que maneja el analisis de datos
 * con analytics
 */
@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  /**
   * Constructor
   *
   * @param db conexion con base de datos
   */
  constructor(
    private analytics: AngularFireAnalytics,
    private dbService: DbService,
    private injector: EnvironmentInjector,
  ) {
  }

  /**
   * Envia la info necesaria al analytics
   *
   * @param nameEvent nombre del evento a registrar
   * @param info objeto a enviar con el evento
   */
  async sendAnalyticsInfo(nameEvent: string, info: InfoEvent) {
    try {
      await runInInjectionContext(this.injector, () => this.analytics.logEvent(nameEvent, info)).then(async () => {
        await this.dbService.add(`restaurants/${info.restaurant_id}/metric`, info).then(() => {
        }).catch(() => {
        });
      });
    } catch (error) {
    }
  }

  /**
   * Envia la info de una nueva calificacion
   *
   * @param info objeto a enviar con el evento
   */
  async sendRateInfo(info: InfoEvent) {
    try {
      await this.dbService.add(`restaurants/${info.restaurant_id}/rates`, info).then((r: any) => {
      }).catch((r: any) => {
      });
    } catch (error) {
    }
  }


}
